// https://gist.github.com/Fluidbyte/2973986
import extended_json from "./data/extended.json"
import popular_json from "./data/popular.json"

type ExtendedCurrencyInfo = {
  symbol: string
  name: string
  symbol_native: string
  decimal_digits: number
  rounding: number
  code: string
  name_plural: string
}

export const extended: Record<string, ExtendedCurrencyInfo> = extended_json
export const popular: Record<string, string> = popular_json

export const extendedInfo = extended

export function format(
  value?: number,
  currency?: string,
  fractionDigits: number = 2,
) {
  if (value == null || currency == null) return ""
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
      currency,
      currencyDisplay: "symbol",
    }).format(value)
  } catch (err: any) {
    console.warn("utils/currencies:format", err.toString())
    return ""
  }
}

export function getCurrencySymbolFromCurrencyCode(currency?: string) {
  let c = ""
  if (!!currency) {
    const fp = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      currencyDisplay: "symbol",
    }).formatToParts(1)

    c = fp.find((f) => f.type === "currency")?.value || ""
  }

  return c
}

export function getCurrencyNameFromCurrencyCode(
  currencyCode?: string | null,
): string {
  if (!currencyCode) return ""

  return extendedInfo[currencyCode].name ?? ""
}

export type CurrencyOption = {
  value: string
  label: string
  symbol: string
  popular: boolean
}

const popularOptions: Array<CurrencyOption> = Object.keys(popular).map((x) => ({
  symbol: extendedInfo[x]?.symbol ?? x,
  label: extendedInfo[x]?.name ?? x,
  value: x,
  popular: true,
}))

const allOptions: Array<CurrencyOption> = Object.keys(extendedInfo).map(
  (x) => ({
    symbol: extendedInfo[x]?.symbol ?? x,
    label: extendedInfo[x]?.name ?? x,
    value: x,
    popular: false,
  }),
)

export const currency_options = popularOptions.concat(allOptions)
